// Web and native actions
export const NOTIFY_LOADING_ENTITIES = 'NOTIFY_LOADING_ENTITIES';
export const NOTIFY_LOADING_ENTITY = 'NOTIFY_LOADING_ENTITY';
export const LOAD_ENTITIES = 'LOAD_ENTITIES';
export const LOAD_ENTITY_INFO = 'LOAD_ENTITY_INFO';
export const SHOW_ENTITY_DESC = 'SHOW_ENTITY_DESC';
export const HIDE_ENTITY_DESC = 'HIDE_ENTITY_DESC';
export const APPEND_NOT_GROUP_PARAM_TO_META = 'APPEND_NOT_GROUP_PARAM_TO_META';
export const SAVE_UNEXPANDED_GROUP_TERMS = 'SAVE_UNEXPANDED_GROUP_TERMS';
